export default "__VITE_ASSET__CXXy4xKd__"